import {Value} from "patient-ping-remedy/packages/dropdown-list/lib/DropdownList";
import Genders from "@manual_encounters/constants/Genders";

const { MALE, FEMALE, NON_BINARY, OTHER } = Genders;
export const genderOptions: Value[] = [MALE, FEMALE, NON_BINARY, OTHER].map((gender) => (
  { value: gender, label: gender }
));

export const raceOptions: Value[] = [
  { value: 'AMERICAN_INDIAN_OR_ALASKA_NATIVE' , label: 'American Indian or Alaska Native' },
  { value: 'ASIAN', label: 'Asian' },
  { value: 'BLACK_OR_AFRICAN_AMERICAN', label: 'Black or African American' },
  { value: 'NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER', label: 'Native Hawaiian or Other Pacific Islander' },
  { value: 'OTHER_RACE' , label: 'Other Race'},
  { value: 'UNKNOWN' , label: 'Unknown'},
  { value: 'WHITE' , label: 'White'},
];

export const ethnicityOptions: Value[] = [
  { value: 'HISPANIC_OR_LATINO' , label: 'Hispanic or Latino'},
  { value: 'NOT_HISPANIC_OR_LATINO' , label:  'Not Hispanic or Latino'},
  { value: 'UNKNOWN' , label: 'Unknown'},
];

export const veteranOptions: Value[] = [
  { value: 'VETERAN' , label: 'Veteran'},
  { value: 'NOT_A_VETERAN' , label: 'Not a veteran'},
  { value: 'UNKNOWN' , label: 'Unknown'},
];

export const maritalStatusOptions: Value[] = [
  { value: 'ANNULLED' , label: 'Annulled'},
  { value: 'DIVORCED' , label: 'Divorced'},
  { value: 'INTERLOCUTORY' , label: 'Interlocutory'},
  { value: 'LEGALLY_SEPARATED' , label: 'Legally separated'},
  { value: 'MARRIED' , label: 'Married'},
  { value: 'COMMON_LAW' , label: 'Common law'},
  { value: 'POLYGAMOUS' , label: 'Polygamous'},
  { value: 'DOMESTIC_PARTNER' , label: 'Domestic partner'},
  { value: 'UNMARRIED' , label: 'Unmarried'},
  { value: 'NEVER_MARRIED' , label: 'Never married'},
  { value: 'WIDOWED' , label: 'Widowed'},
  { value: 'OTHER' , label: 'Other'},
  { value: 'UNKNOWN' , label: 'Unknown'},
];

export const languageOptions: Value[] = [
  { value: 'ENGLISH' , label: 'English'},
  { value: 'SPANISH' , label: 'Spanish'},
  { value: 'VIETNAMESE', label: 'Vietnamese'},
  { value: 'AMERICAN_SIGN_LANGUAGE' , label: 'American sign language'},
  { value: 'RUSSIAN' , label: 'Russian'},
  { value: 'PORTUGUESE' , label: 'Portuguese'},
  { value: 'CANTONESE' , label: 'Cantonese' },
  { value: 'KOREAN' , label: 'Korean'},
  { value: 'MANDARIN' , label: 'Mandarin'},
  { value: 'HAITIAN_CREOLE' , label: 'Haitian creole'},
  { value: 'OTHER' , label: 'Other'},
  { value: 'UNKNOWN' , label: 'Unknown'},
];

export const phoneTypeOptions: Value[] = [
  { value: 'mobile', label: 'Mobile' },
  { value: 'home', label: 'Home' },
  { value: 'other', label: 'Other' },
];

export const relationshipOptions: Value[] = [
  { value: 'MOTHER', label: 'Mother' },
  { value: 'FATHER', label: 'Father' },
  { value: 'PARENT', label: 'Parent' },
  { value: 'DAUGHTER', label: 'Daughter' },
  { value: 'SON', label: 'Son' },
  { value: 'CHILD', label: 'Child' },
  { value: 'SISTER', label: 'Sister' },
  { value: 'BROTHER', label: 'Brother' },
  { value: 'SIBLING', label: 'Sibling' },
  { value: 'SPOUSE', label: 'Spouse' },
  { value: 'HUSBAND', label: 'Husband' },
  { value: 'WIFE', label: 'Wife' },
  { value: 'PARTNER', label: 'Partner' },
  { value: 'SIGNIFICANT_OTHER', label: 'Significant other' },
  { value: 'FRIEND', label: 'Friend' },
  { value: 'GRANDPARENT', label: 'Grandparent' },
  { value: 'GRANDCHILD', label: 'Grandchild' },
  { value: 'AUNT', label: 'Aunt' },
  { value: 'EMPLOYEE', label: 'Employee' },
  { value: 'EMPLOYER', label: 'Employer' },
  { value: 'OTHER_RELATIVE', label: 'Other relative' },
  { value: 'OTHER', label: 'Other' },
  { value: 'UNKNOWN', label: 'Unknown' },
  { value: 'UNMAPPED', label: 'Unmapped' },
];
